import React from 'react';
import { ConsignmentResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface ConsignmentDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  consignment: ConsignmentResponse | null;
}

export const ConsignmentDeleteDialog: React.FC<ConsignmentDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  consignment,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="consignment"
      itemId={consignment?.id || ''}
    />
  );
};
